import { useLocation } from 'react-router-dom'
import { useContext, useMemo } from 'react'
import AdSlot from './AdSlot'
import '../assets/css/Ad.css'
import { CookieConsentContext } from '../context/CookieConsentContext';

function TopBillboardLayout({unitPath, divId}) {
    const { cookieConsentMode } = useContext(CookieConsentContext);
    const location = useLocation();
    const sizes = useMemo(() => [[970, 250], [300, 250]], []);
    const mappingConfig = useMemo(() => [
        { viewport: [1024, 0], slotSizes: [[970, 250]] }, 
        { viewport: [0, 0], slotSizes: [[300, 250]] }  
    ], []);

    return (
        cookieConsentMode &&
        <div className="top-billboard">
            <AdSlot 
                key={location.pathname}
                divId={divId}
                unitPath={unitPath}
                sizes={sizes}
                mappingConfig={mappingConfig} 
            />
        </div>
    )
}

export default TopBillboardLayout;